import { render } from "./EmployeeDeniedLiquidations.vue?vue&type=template&id=47e90c12"
import script from "./EmployeeDeniedLiquidations.vue?vue&type=script&lang=js"
export * from "./EmployeeDeniedLiquidations.vue?vue&type=script&lang=js"

import "./EmployeeDeniedLiquidations.vue?vue&type=style&index=0&id=47e90c12&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__